import React, { useContext, useEffect } from "react"
import { routes } from "../../routes"
import { InterfaceContext } from "../../context/InterfaceContext"
import {
  allPreferencesAccepted,
  onlyNecessaryPreferences,
  saveCookiePreferences,
} from "./utils"
import { linkToExternalLegalPages } from "../footer/Footer"
import { ButtonAction } from "../button/ButtonAction"
import { ButtonNeutral } from "../button/ButtonNeutral"
import { ButtonTransparent } from "../button/ButtonTransparent"
import { useTranslation } from "react-i18next"
import { translationKeys } from "../../util/translationKeys"
import { BodyTextRegular } from "../typography/text"

const GATSBY_COOKIES = process.env.GATSBY_COOKIES || ""

export const CookieBanner = () => {
  const isConsentRequired = !localStorage.getItem("cookiePreferences")

  const { t } = useTranslation()

  const { setCookieModalVisible, cookieBannerVisible, setCookieBannerVisible } =
    useContext(InterfaceContext)

  useEffect(() => {
    setCookieBannerVisible(isConsentRequired)
  }, [])

  if (!cookieBannerVisible) {
    return <></>
  }

  return (
    <div className="fixed items-center md:items-end gap-4 flex-col rounded p-6 bottom-4 md:bottom-10 md:right-10 shadow-flyout z-floating flex w-full md:w-1/2 bg-white">
      <BodyTextRegular>
        {t(translationKeys.comboCookiesDescription)}{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={
            linkToExternalLegalPages ? GATSBY_COOKIES : routes.legal.cookies
          }
          className="cursor-pointer text-blue-800 underline"
        >
          {t(translationKeys.comboCookiesPolicy)}
        </a>
        .
      </BodyTextRegular>
      <div className="flex flex-col md:flex-row gap-3 w-full">
        <ButtonAction
          onClick={() => {
            saveCookiePreferences(allPreferencesAccepted)
            setCookieBannerVisible(false)
          }}
          size="large"
        >
          {t(translationKeys.comboAccept)}
        </ButtonAction>
        <ButtonNeutral
          onClick={() => {
            setCookieBannerVisible(false)
            setCookieModalVisible(true)
          }}
          size="large"
        >
          {t(translationKeys.comboManage)}
        </ButtonNeutral>
        <ButtonTransparent
          onClick={() => {
            saveCookiePreferences(onlyNecessaryPreferences)
            setCookieBannerVisible(false)
          }}
          size="large"
        >
          {t(translationKeys.comboCookiesNecessary)}
        </ButtonTransparent>
      </div>
    </div>
  )
}
